export const version = "ethers/5.4.5";
//# sourceMappingURL=_version.js.map